<template>
    <div class="register__step" data-step="membership" v-bind:class="{'active': $store.state.step == 'membership'}">
        <h3>Membership</h3>
        <p>We have a few options for you, depending on your needs.  Please review the options below and select a membership plan.</p>

        <div class="register__memberships-wrapper">
            <div class="register__memberships">
                <div class="register__membership" v-for="( plan, plan_index ) in $store.state.plans" v-bind:key="plan_index" v-bind:data-tier="plan.slug" v-bind:class="{ 'register__membership--selected' : ( ( $store.state.signup.plan === plan.slug ) ? true : false ) }" v-on:click="set_membership( plan.slug )">
                    <h3 class="register__membership-title">{{ plan.name }}</h3>
                    <div class="register__membership-cost">{{ plan.cost | currency }} <em>annually</em><span class="register__membership-cost-asterisk" v-if="plan.legal"><i class="fal fa-asterisk" aria-hidden="true"></i></span></div>

                    <ul class="register__membership-perks">
                        <li v-for="( perk, perk_index ) in $store.state.perks" v-bind:key="perk_index" class="register__membership-perk" v-bind:class="{ 'register__membership-perk--premium': ( ( perk.is_premium ) && ( plan.slug === 'premium' ) ) }">
                            <span v-if="( ( !perk.is_premium ) || ( ( perk.is_premium ) && ( plan.slug === 'premium' ) ) )">{{ perk.name }}</span>
                            <span v-else class="disabled">{{ perk.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="register__memberships-planner">
                <div class="register__memberships-planner-inner" v-for="( plan, plan_index ) in $store.state.plans" v-bind:key="plan_index" v-bind:class="{ 'hidden': ( ( $store.state.signup.plan === plan.slug ) ? false : true ) }" v-bind:data-tier="plan.slug">
                    <div class="register__memberships-planner-description">
                        <div class="register__memberships-planner-description-inner" v-html="plan.description"></div>
                        <button class="btn btn-primary" v-on:click="$store.dispatch( 'step_control', { to: 'payment' } );">Choose This Plan</button>
                    </div>
                    <div class="register__memberships-planner-legal" v-html="plan.legal" v-if="plan.legal"></div>
                </div>
            </div>
        </div>

        <footer class="register__step-footer">
            <button class="btn btn-secondary" data-direction="back" v-on:click="$store.dispatch( 'step_control', { to: 'interests' } );"><i class="fas fa-chevron-left" aria-hidden="true"></i> Back</button>
            <button class="btn btn-primary" data-direction="next" v-on:click="$store.dispatch( 'step_control', { to: 'payment' } );">Payment <i class="fas fa-chevron-right" aria-hidden="true"></i></button>
        </footer>
    </div>
</template>

<script>
export default {
    name: "DVCARegisterMembership",
    methods: {
        set_membership: function( type ) {

            var selected_plan = this.$store.state.plans.filter(x => x.slug == type)[0];

            this.$store.commit( 'set_value', { collection: 'signup', attribute: 'plan', data: type } );
            this.$store.commit( 'set_value', { collection: 'signup', attribute: 'plan_details', data: selected_plan } );
        }
    }
}
</script>
